module.exports = __webpack_public_path__ + "img/loesungen-fuer-jede-lebenslage_kachl_TRUEBEAUTY.b37d1ac9.png";